import { createClickBody } from "../../helpers/location";

export default function Clicks(location) {
    const click = createClickBody(location);
    const { pageType } = click;

    if (typeof click.crmSessionId === 'undefined' && (pageType === "thankyouPage" || pageType === "upsellPage1")) {
        location.push("/");
    } else {
        fetch(process.env.NEXT_PUBLIC_REACT_APP_API + "/clicks", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(click),
        })
          .then((res) => res.json())
          .then((res) => {
              if (res.error) {
                  throw res.error;
              }
              if (res.crmSessionId && pageType !== "thankyouPage") {
                  try {
                      localStorage.setItem("crmSessionId", res.crmSessionId);
                  } catch (error) {
                  }
              }
              if (pageType === "thankyouPage") {
                  if (localStorage && localStorage.getItem("crmSessionId")) {
                      localStorage.setItem("crmSessionIdLast", res.crmSessionId);
                      localStorage.removeItem("crmSessionId");
                  }
              }
          })
          .catch((error) => {
              let salePage = window.location.href;
              let salePageURLArr = salePage.split("/");
              let salePageURL = (
                salePageURLArr[0] +
                "//" +
                salePageURLArr[2]
              ).replace(/\/+$/, "");
              fetch(salePageURL + "/crm/clicks", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify(click),
              })
                .then((res2) => res2.json())
                .then((res2) => {
                    if (res2.error) {
                        throw res2.error;
                    }
                    if (res2.crmSessionId && pageType !== "thankyouPage") {
                        try {
                            localStorage.setItem("crmSessionId", res2.crmSessionId);
                        } catch (error) {
                        }
                    }
                    if (pageType === "thankyouPage") {
                        if (localStorage && localStorage.getItem("crmSessionId")) {
                            localStorage.setItem("crmSessionIdLast", res2.crmSessionId);
                            localStorage.removeItem("crmSessionId");
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
          });
    }
}
